import { NOTIFICATION_TYPE } from '@/constants/notification';
import { STORAGE_KEY } from '@/constants/storage';
import router from '@/router';
import { fetchRefreshToken, fetchUser, login } from '@/services/auth.service';
import { cookieParse } from '@/utils/utils';
import VueCookies from 'vue-cookies';

export const AuthModule = {
    state: () => ({
        accessToken:
            cookieParse(VueCookies.get(STORAGE_KEY.ACCESS_TOKEN)) || null,
        refreshToken:
            cookieParse(VueCookies.get(STORAGE_KEY.REFRESH_TOKEN)) || null,
        user: null,
        currentLoginMessage: '',
    }),
    mutations: {
        setAccessToken(state, data) {
            let accessToken;
            if (data) {
                accessToken = data.includes('Bearer') ? data : 'Bearer ' + data;
            } else {
                accessToken = null;
            }
            state.accessToken = accessToken;
            VueCookies.set(
                STORAGE_KEY.ACCESS_TOKEN,
                accessToken,
                Infinity,
                null,
                '.' + process.env.VUE_APP_DOMAIN
            );
        },
        setRefreshToken(state, data) {
            state.refreshToken = data;
            VueCookies.set(
                STORAGE_KEY.REFRESH_TOKEN,
                data,
                Infinity,
                null,
                '.' + process.env.VUE_APP_DOMAIN
            );
        },
        setUser(state, data) {
            state.user = data;
        },
        setCurrentLoginMessage(state, data) {
            state.currentLoginMessage = data;
        },
        clear(state) {
            state.accessToken = null;
            state.refreshToken = null;
            state.user = null;
            VueCookies.remove(
                STORAGE_KEY.ACCESS_TOKEN,
                null,
                '.' + process.env.VUE_APP_DOMAIN
            );
            VueCookies.remove(
                STORAGE_KEY.REFRESH_TOKEN,
                null,
                '.' + process.env.VUE_APP_DOMAIN
            );
        },
    },
    actions: {
        async fetchUser({ commit }) {
            const { data } = await fetchUser();
            commit('setUser', data);
            commit('website/setWebsite', data.website, {
                root: true,
            });
        },
        async fetchRefreshToken({ commit, state }, refreshToken) {
            const { data } = await fetchRefreshToken(refreshToken);
            if (data.accessToken && state.accessToken) {
                commit('setAccessToken', data.accessToken);
            }
        },
        login(context, form) {
            return login(form);
        },
        setToken({ commit }, data) {
            commit('setAccessToken', data.accessToken);
            commit('setRefreshToken', data.refreshToken);
            this._vm.$helpers.leaveLoginPage();
        },
        logout({ state, commit }, options = {}) {
            const { redirect = true, needContinueUrl = true } = options;
            if (state.user && this._vm && this._vm.$socket) {
                this._vm.$socket.emit('leave', {
                    type: NOTIFICATION_TYPE,
                    username: state.user.username,
                    token: state.accessToken,
                });
            }
            commit('clear');
            commit('user/resetBalance', null, { root: true });
            commit('website/resetWebsite', null, { root: true });
            commit('sms/resetBrandNames', null, { root: true });
            commit('sms/resetSmsCreatingData', null, { root: true });
            commit('sms/resetTrialDemoBrandname', null, { root: true });
            commit('card/setCards', [], { root: true });

            if (redirect) {
                const route = this._vm.$helpers.prepareRouteToLogin(
                    router.currentRoute,
                    needContinueUrl
                );
                router.push(route).catch(() => {});
            }
        },
    },
    getters: {
        loggedIn(state) {
            return !!state.accessToken;
        },
        user(state) {
            return state.user || {};
        },
    },
    namespaced: true,
};
